import { styled, shape, spacing } from '@hub-la/design-system';
import { keyframes } from '@mui/material';

let _ = t => t,
  _t,
  _t2;
const backgroundWave = keyframes(_t || (_t = _`
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 50% 100%;
  }

  100% {
    background-position: 0% 50%;
  }
`));
const EventLiveContainer = styled('div')(_t2 || (_t2 = _`
  border-radius: ${0};
  background: linear-gradient(104.83deg, #d8fd6c 0%, #dde2fe 20.9%, #79fbac 100%);
  background-size: 400% 400%;
  animation: ${0} 5s ease infinite;
  padding-left: ${0};
  padding-right: ${0};
  width: 104px;
  height: 26px;
`), shape('extraSmall'), backgroundWave, spacing(1), spacing(1));

export { EventLiveContainer };
